<template>
  <div class="lad-filter--date-content">
    <slot name="before-range" />

    <LadFilterDateRange
      :value="value"
      :open="open"
      :width-sidebar="isAdvanced"
      :handle-apply="handleApply"
      @update-values="updateValues"
    >
      <el-button
        slot="buttons"
        :type="type"
        plain
        :disabled="btnDisabled"
        icon="el-icon-date"
        @click="handleOpenPicker"
      >
        <template v-if="hasDefaultLabel">{{ defaultLabel }}</template>
        <template v-else>{{
          $t('filters.date.from_to', { from, to })
        }}</template>
      </el-button>
    </LadFilterDateRange>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-relative-parent-imports
import LadFilterDateRange from '../ranges/date-range'
import LadFilterCommon from './common'

export default {
  name: 'LadFilterDate',
  components: { LadFilterDateRange },
  extends: LadFilterCommon,
  props: {
    label: { type: String, default: '' },
    // eslint-disable-next-line vue/no-boolean-default
    isAdvanced: { type: Boolean, default: true },
    btnDisabled: { type: Boolean, default: false },
    // eslint-disable-next-line vue/require-valid-default-prop
    values: { type: Array, default: () => [] },
    isCustom: { type: Boolean, default: false },
  },
  data() {
    return {
      open: 0,
    }
  },
  computed: {
    defaultLabel() {
      return this.label ? this.label : this.$t('filters.date.label')
    },
    from() {
      return this.firstFilter
        ? this.$dayjs(this.firstFilter).format('D, MMM')
        : ''
    },
    to() {
      return this.lastFilter
        ? this.$dayjs(this.lastFilter).format('D, MMM')
        : ''
    },
  },
  watch: {
    values: {
      immediate: true,
      handler(newValue) {
        if (this.isCustom) this.value = newValue
      },
    },
  },
  beforeMount() {
    this.filterType = 'date'

    if (this.searchForm.filters[this.filterType].length > 0) {
      const _get = this.searchForm.filters[this.filterType]
      this.filter = Array.isArray(_get) ? _get : [_get]

      this._enableLabel()
    }
  },
  mounted() {
    if (this.filter.length > 0) {
      this.value = this.filter
    }
  },
  methods: {
    handleOpenPicker(event) {
      this.open++
    },
    async handleApply() {
      this.filter =
        this.value.length === 2
          ? [
              this.$dayjs(this.value[0]).format('YYYY-MM-DD'),
              this.$dayjs(this.value[this.value.length - 1]).format(
                'YYYY-MM-DD'
              ),
            ]
          : []
      await this.$store.dispatch('search/updateFormFilter', {
        filter: this.filterType,
        data: this.filter,
      })

      if (this.filter.length) {
        this._enableLabel()
      } else {
        this._resetLabel()
        this.visible = false
      }
      this.$emit('change')
    },
    updateValues(list) {
      this.value = list

      this.$emit('update-values', this.value)
      this.$emit('change')
    },
  },
}
</script>
